import { TruncatedText } from '@/components/ui'
import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { CellContext } from '@/components/ui/table/types'
import type { Transaction } from '@/modules/projects'
import { BADGE_CLASS } from '@/modules/projects/components/rowBadgeClass'
import { isSecuritiesTrade } from '@/modules/projects/utils'

export const DescriptionCell = (cell: CellContext<Transaction, string>) => {
  const searchQuery = cell.table.options.meta?.searchQuery
  const transaction = cell.row.original

  return (
    <span className="flex min-w-0 items-center">
      <TruncatedText text={cell.getValue()}>
        <HighlightText text={cell.getValue()} query={searchQuery} />
      </TruncatedText>
      {transaction.internalTransfer ? <InternalTransferBadge /> : null}
      {isSecuritiesTrade(transaction) ? <SecuritiesTradeBadge /> : null}
    </span>
  )
}

// Marks a buy or sell inside a brokerage account. Cash became securities or the reverse, so the row
// stays in the ledger and the balance chain but is left out of money in / money out.
const SecuritiesTradeBadge = () => (
  <span
    title="Securities bought or sold inside this account; not counted as money in or out"
    className={BADGE_CLASS}
  >
    Trade
  </span>
)

// Marks a deposit-sweep transfer between the customer's own buckets. Shown in the ledger but
// excluded from reconcile and the money totals.
const InternalTransferBadge = () => (
  <span
    title="Internal transfer between the customer's own cash buckets; not counted in totals or reconcile"
    className={BADGE_CLASS}
  >
    Internal
  </span>
)
